export default {
      getErrors: state => {
        return state.errors;
      },
      getProductClass: state => {
        return state.productClass;
      },
      getConfiguration: state => {
        return state.configuration;
      },
      getOrderSummary: state => {
        return state.orderSummary;
      },
      getOrderDetails: state => {
        return state.OrderDetails;  
      },
      getPermitNumber: state => {
        return state.permitNumber;
      },
      getLoading: state => {
        return state.loading;
      }
    };